export class ProductManagementModel {
    clientId: string;
    brokerAccountClientId: string;
    billingClientId: string;
    serviceOfferCode: string;
    specName: string;
    quantity: number
    totalLicensesInUse: number
    productDesc: string;
    class: string;
    isSingleQuantity:string;
    
    constructor() {
        this.clientId = undefined;
        this.brokerAccountClientId = undefined;
        this.billingClientId = undefined;
        this.serviceOfferCode = undefined;
        this.quantity = undefined;
        this.specName = undefined;
        this.totalLicensesInUse = undefined;
        this.productDesc = undefined;
        this.class = undefined;
        this.isSingleQuantity =undefined;
    }
}